import React from "react";

import CoverageAreaList from "./coverageAreaList/CoverageAreaList";

const CoverageArea = () => {
  return <CoverageAreaList />;
};

export default CoverageArea;
